// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  background: #ffffff;
  border-radius: 16px;
  position: relative;
  width: 100%;
}
.wrapper .close-icon {
  position: absolute;
  top: 15px;
  right: 15px;
  margin: 0;
  background: transparent;
  width: 30px;
  height: 30px;
  padding: 0;
  z-index: 99;
  font-size: 24px;
  color: #000;
}
.wrapper .close-icon ion-icon {
  width: 100%;
  height: 100%;
}
.wrapper .dialog-title {
  font-size: 22px;
  font-family: AppFontBold, sans-serif; /* Condensed look */
  color: #262626;
  margin: 10px 0 5px;
  text-align: center;
}
.wrapper .dialog-subtitle {
  font-size: 14px;
  font-family: AppFontMedium, sans-serif;
  color: #555555;
  margin: 0 0 20px;
  text-align: center;
}
.wrapper .selection-section {
  width: 100%;
  text-align: center;
}
.wrapper .selection-section .section-label {
  font-size: 12px;
  font-weight: bold;
  text-transform: uppercase;
  font-family: AppFontBold, sans-serif;
  color: #262626;
  letter-spacing: 1px;
  margin-bottom: 15px;
}
.wrapper .selection-section .time-selection-wrapper {
  width: 100%;
  padding: 0;
}
.wrapper .continue-btn {
  width: 100%;
  margin-top: 20px;
  --background: var(--ion-color-primary); /* Gold */
  --border-radius: 300px; /* Slightly rounded for modern look */
  font-family: AppFontBold, sans-serif;
  text-transform: uppercase;
  font-size: 14px;
  height: 45px;
  color: #fff;
}`, "",{"version":3,"sources":["webpack://./src/app/components/before-create-order-select-time-dialog/before-create-order-select-time-dialog.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;AACJ;AACC;EACO,kBAAA;EACA,SAAA;EACA,WAAA;EACA,SAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,WAAA;EACA,eAAA;EACA,WAAA;AACR;AACQ;EACI,WAAA;EACA,YAAA;AACZ;AAGI;EACI,eAAA;EACA,oCAAA,EAAA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;AADR;AAII;EACI,eAAA;EACA,sCAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;AAFR;AAKI;EACI,WAAA;EACA,kBAAA;AAHR;AAKQ;EACI,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,oCAAA;EACA,cAAA;EACA,mBAAA;EACA,mBAAA;AAHZ;AAMQ;EACI,WAAA;EACA,UAAA;AAJZ;AAQI;EACI,WAAA;EACA,gBAAA;EACA,sCAAA,EAAA,SAAA;EACA,sBAAA,EAAA,qCAAA;EACA,oCAAA;EACA,yBAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;AANR","sourcesContent":[".wrapper {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: 20px;\n    background: #ffffff;\n    border-radius: 16px;\n    position: relative;\n    width: 100%;\n\n\t.close-icon {\n        position: absolute;\n        top: 15px;\n        right: 15px;\n        margin: 0;\n        background: transparent;\n        width: 30px;\n        height: 30px;\n        padding: 0;\n        z-index: 99;\n        font-size: 24px;\n        color: #000;\n        \n        ion-icon {\n            width: 100%;\n            height: 100%;\n        }\n    }\n\n    .dialog-title {\n        font-size: 22px;\n        font-family: AppFontBold, sans-serif; /* Condensed look */\n        color: #262626;\n        margin: 10px 0 5px;\n        text-align: center;\n    }\n\n    .dialog-subtitle {\n        font-size: 14px;\n        font-family: AppFontMedium, sans-serif;\n        color: #555555;\n        margin: 0 0 20px;\n        text-align: center;\n    }\n\n    .selection-section {\n        width: 100%;\n        text-align: center;\n        \n        .section-label {\n            font-size: 12px;\n            font-weight: bold;\n            text-transform: uppercase;\n            font-family: AppFontBold, sans-serif;\n            color: #262626;\n            letter-spacing: 1px;\n            margin-bottom: 15px;\n        }\n\n        .time-selection-wrapper {\n            width: 100%;\n            padding: 0;\n        }\n    }\n\n    .continue-btn {\n        width: 100%;\n        margin-top: 20px;\n        --background: var(--ion-color-primary); /* Gold */\n        --border-radius: 300px; /* Slightly rounded for modern look */\n        font-family: AppFontBold, sans-serif;\n        text-transform: uppercase;\n        font-size: 14px;\n        height: 45px;\n        color: #fff;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
